"use strict";
/**
 * @module Services.RemoteServers
 */
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * The response of RemoteServers CREATE_REMOTE_SERVER service
 */
var CreateRemoteServerResult = /** @class */ (function () {
    /**
     * Create a new CreateRemoteServerResult instance
     *
     * @param server  the remote server
     * @param errors  any errors that might have occurred
     */
    function CreateRemoteServerResult(server, errors) {
        this.server = server;
        this.errors = errors;
    }
    return CreateRemoteServerResult;
}());
exports.CreateRemoteServerResult = CreateRemoteServerResult;



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/services/remote-servers/create-remote-server-result.js
// module id = 1603
// module chunks = 1